import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  ko: {
    translation: {
      already_checkout: "이미 체크아웃 처리된 예약입니다.",
      check_reservation_status: "예약 상태를 확인해 주세요.",
      inquiry: "문의하기",
      notice_title: "안내 메시지",
      contact_front_desk: "문의사항이 있으시면,\n프론트 데스크로 연락 주시기 바랍니다.",
      unpaid_balance: "미납 요금이 있습니다. 프론트로 문의 해주세요.",
      not_found_info: "hotel_code 또는 reservation_number를 찾을 수 없습니다.",
      not_found_page: "페이지를 찾을 수 없습니다.",
      check_url: "URL 주소를 확인해 주세요.",
      back: "뒤로가기",
      cancel: "취소",

      // booking
      reservation_search: "예약 조회",
      name: "예약자 성함",
      same_name: "예약 시 입력한 이름과 동일하게 입력해 주세요.",
      search: "조회",

      // dueIn
      welcome: "고객님, 환영합니다.",
      room: "객실",
      reservation_info: "예약 정보",
      reservation_status: "예약 상태",
      reservation_no: "예약 번호",
      checkin: "체크인",
      checkout: "체크아웃",
      nights: "숙박 일수",
      checkin_available_time: "체크인은 {{time}} 이후에 가능합니다.",

      // policy-agree
      policy_agree: "약관 동의",
      agree_all: "전체 동의",
      privacy_collect: "개인정보 수집 · 이용에 대한 동의 (비대면 체크인)",
      privacy_third_party: "개인정보의 제3자 제공 동의",
      location_service: "위치 기반 서비스 이용약관",
      age_over_14: "만 14세 이상 이용 확인",
      smart_checkin_service: "에이치투오 스마트 체크인 서비스 이용약관",
      marketing_consent: "마케팅 활용을 위한 개인정보 수집 · 이용 동의",
      confirm: "확인",
      close: "닫기",
      detail: "자세히",
      required: "필수",
      optional: "선택",

      // auth
      self_authentication: "본인 인증",
      verify_kakao: "카카오 로그인을 통해 본인 인증을 진행해 주세요.",
      kakao_login: "카카오 로그인",
      adult_confirm: "만 19세 이상 성인입니다.",
      birthdate_verified: "투숙일 기준 생일 경과 확인",

      // room
      room_select: "객실 선택",
      room_search: "객실 번호 또는 객실 유형으로 검색",
      selected_room: "선택된 객실",
      select: "선택",

      // checkin
      password: "객실 비밀번호",
      mobile_key: "모바일키",
      elevator: "엘리베이터",
      public_facilities: "공용시설",
      notice: "공지사항",
      other_reservations: "다른 예약 조회",

      // location
      location_gps_notice: "※ GPS 상태에 따라 위치 오차가 발생할 수 있습니다.",
      location_checking: "현재 위치 확인 중...",
      location_valid: "체크인 가능한 지역에 있습니다.",
      location_not_supported: "이 브라우저에서는 Geolocation이 지원되지 않습니다.",
      location_out_of_range: "호텔 반경 {{radius}}km 이내에서 서비스 이용이 가능합니다.",
      location_permission_denied: "위치 접근 권한이 없습니다. 위치 접근 허용 후 다시 시도해 주세요.",
      location_position_unavailable: "위치를 찾을 수 없습니다. 다시 시도해 주세요.",
      location_timeout: "위치 정보 응답 시간이 초과되었습니다. 다시 시도해 주세요.",
      location_default_error: "위치 조회 중 알 수 없는 오류가 발생했습니다.",

      //checkout
      checkout_confirm: "체크아웃 하시겠습니까?",
      checkout_noReentry: "체크아웃 이후에는 객실에 다시 입장할 수 없습니다.",
      checkout_complete: "체크아웃 완료",
      service_reward_message: "항상 보다 나은 서비스로\n고객님의 성원에 보답하겠습니다.\n감사합니다."
    }
  },
  en: {
    translation: {
      already_checkout: "This reservation has already been checked out.",
      check_reservation_status: "Please check the reservation status.",
      inquiry: "Contact us",
      notice_title: "Notice",
      contact_front_desk: "If you have any inquiries,\nplease contact the front desk.",
      unpaid_balance: "There is an unpaid balance. Please contact the front desk.",
      not_found_info: "hotel_code or reservation_number cannot be found.",
      not_found_page: "Page not found.",
      check_url: "Please check the URL.",
      back: "Back",
      cancel: "Cancel",

      reservation_search: "Reservation Search",
      name: "Booker's Name",
      same_name: "Please enter the same name used for the reservation.",
      search: "Search",

      welcome: "Welcome, guest.",
      room: "Room",
      reservation_info: "Reservation information",
      reservation_status: "Reservation status",
      reservation_no: "Reservation number",
      checkin: "Check-in",
      checkout: "Check-out",
      nights: "Number of nights",
      checkin_available_time: "Check-in is available after {{time}}.",

      policy_agree: "Agree to policies",
      agree_all: "Agree to all",
      privacy_collect: "Consent to Collection and Use of Personal Information (Non-face-to-face Check-in)",
      privacy_third_party: "Consent to Provision of Personal Information to Third Parties",
      location_service: "Terms of Use for Location-based Services",
      age_over_14: "Confirmation of Use by Users Aged 14 or Older",
      smart_checkin_service: "H2O Smart Check-in Service Terms of Use",
      marketing_consent: "Consent to Collection and Use of Personal Information for Marketing Purposes",
      confirm: "Confirm",
      close: "Close",
      detail: "Details",
      required: "Required",
      optional: "Optional",

      self_authentication: "Identity verification",
      verify_kakao: "Please verify your identity via Kakao login.",
      kakao_login: "Login with Kakao",
      adult_confirm: "I confirm that I am 19 years of age or older.",
      birthdate_verified: "Birthday Passed by Check-in Date",

      room_select: "Select a room",
      room_search: "Search by room number or type",
      selected_room: "Selected room",
      select: "Select",

      password: "Room password",
      mobile_key: "Mobile key",
      elevator: "Elevator",
      public_facilities: "Public facilities",
      notice: "Notice",
      other_reservations: "Other reservations",

      // location
      location_gps_notice: "※ Location accuracy may vary depending on GPS conditions.",
      location_checking: "Checking current location...",
      location_valid: "You are in a check-in available area.",
      location_not_supported: "Geolocation is not supported in this browser.",
      location_out_of_range: "Service is available within {{radius}}km of the hotel.",
      location_permission_denied: "Location access is denied. Please allow location access and try again.",
      location_position_unavailable: "Location unavailable. Please try again.",
      location_timeout: "Location request timed out. Please try again.",
      location_default_error: "An unknown error occurred while retrieving your location.",

      checkout_confirm: "Are you sure you want to check out?",
      checkout_noReentry: "You will not be able to re-enter the room after checking out.",
      checkout_complete: "Check-out complete",
      service_reward_message: "We will continue to provide better service.\nThank you for your support.\nThank you."
    }
  },
  ja: {
    translation: {
      already_checkout: "すでにチェックアウト済みの予約です。",
      check_reservation_status: "予約状況をご確認ください。",
      inquiry: "お問い合わせ",
      notice_title: "お知らせ",
      contact_front_desk: "ご不明点がございましたら、\nフロントまでご連絡ください。",
      unpaid_balance: "未払い料金があります。フロントへお問い合わせください。",
      not_found_info: "hotel_code または reservation_number が見つかりません。",
      not_found_page: "ページが見つかりません。",
      check_url: "URLをご確認ください。",
      back: "戻る",
      cancel: "キャンセル",

      reservation_search: "予約照会",
      name: "予約者のお名前",
      same_name: "ご予約時に入力したお名前と同じ名前をご入力ください。",
      search: "検索",

      welcome: "ようこそ。",
      room: "客室",
      reservation_info: "予約情報",
      reservation_status: "予約状況",
      reservation_no: "予約番号",
      checkin: "チェックイン",
      checkout: "チェックアウト",
      nights: "宿泊数",
      checkin_available_time: "{{time}}以降にチェックイン可能です。",

      policy_agree: "規約同意",
      agree_all: "すべて同意",
      privacy_collect: "個人情報の収集・利用に関する同意（非対面チェックイン）",
      privacy_third_party: "個人情報の第三者提供への同意",
      location_service: "位置情報サービス利用規約",
      age_over_14: "満14歳以上の利用確認",
      smart_checkin_service: "H2Oスマートチェックインサービス利用規約",
      marketing_consent: "マーケティング活用のための個人情報収集・利用への同意",
      confirm: "確認",
      close: "閉じる",
      detail: "詳細",
      required: "必須",
      optional: "任意",

      self_authentication: "本人確認",
      verify_kakao: "Kakaoログインで本人確認してください。",
      kakao_login: "Kakaoログイン",
      adult_confirm: "私は満19歳以上の成人であることを確認します。",
      birthdate_verified: "宿泊日時点での誕生日経過確認",

      room_select: "客室選択",
      room_search: "客室番号またはタイプで検索",
      selected_room: "選択した客室",
      select: "選択",

      password: "客室パスワード",
      mobile_key: "モバイルキー",
      elevator: "エレベーター",
      public_facilities: "共用施設",
      notice: "お知らせ",
      other_reservations: "他の予約",

      // location
      location_gps_notice: "※ GPS状態によって位置の誤差が生じる場合があります。",
      location_checking: "現在地を確認中...",
      location_valid: "チェックイン可能なエリアにいます。",
      location_not_supported: "このブラウザではGeolocationがサポートされていません。",
      location_out_of_range: "ホテルの半径{{radius}}km以内でご利用いただけます。",
      location_permission_denied: "位置情報へのアクセスが拒否されています。許可後に再試行してください。",
      location_position_unavailable: "位置を取得できません。再試行してください。",
      location_timeout: "位置情報の取得がタイムアウトしました。再試行してください。",
      location_default_error: "位置情報の取得中に不明なエラーが発生しました。",

      checkout_confirm: "チェックアウトしますか？",
      checkout_noReentry: "チェックアウト後は客室に再入室できません。",
      checkout_complete: "チェックアウト完了",
      service_reward_message: "より良いサービスでお応えします。\nありがとうございます。"
    }
  },
  zh: {
    translation: {
      already_checkout: "该预订已办理退房。",
      check_reservation_status: "请确认预订状态。",
      inquiry: "咨询",
      notice_title: "通知",
      contact_front_desk: "如有疑问，\n请联系前台。",
      unpaid_balance: "有未支付费用，请联系前台。",
      not_found_info: "找不到 hotel_code 或 reservation_number。",
      not_found_page: "未找到页面。",
      check_url: "请检查URL地址。",
      back: "返回",
      cancel: "取消",

      reservation_search: "预订查询",
      name: "预订人姓名",
      same_name: "请输入与预订时填写的姓名一致的名字。",
      search: "查询",

      welcome: "欢迎您。",
      room: "房间",
      reservation_info: "预订信息",
      reservation_status: "预订状态",
      reservation_no: "预订号",
      checkin: "入住",
      checkout: "退房",
      nights: "住宿晚数",
      checkin_available_time: "{{time}}之后可办理入住。",

      policy_agree: "同意条款",
      agree_all: "全部同意",
      privacy_collect: "个人信息收集及使用同意（非面对面办理入住）",
      privacy_third_party: "个人信息向第三方提供的同意",
      location_service: "位置信息服务使用条款",
      age_over_14: "14周岁以上使用确认",
      smart_checkin_service: "H2O智能入住服务使用条款",
      marketing_consent: "用于营销的个人信息收集及使用同意",
      confirm: "确认",
      close: "关闭",
      detail: "详情",
      required: "必需",
      optional: "可选",

      self_authentication: "身份验证",
      verify_kakao: "请通过Kakao登录完成验证。",
      kakao_login: "Kakao登录",
      adult_confirm: "我确认自己已年满19周岁。",
      birthdate_verified: "截至入住日期生日已过确认",

      room_select: "选择房间",
      room_search: "按房号或类型搜索",
      selected_room: "已选房间",
      select: "选择",

      password: "房间密码",
      mobile_key: "手机钥匙",
      elevator: "电梯",
      public_facilities: "公共设施",
      notice: "公告",
      other_reservations: "其他预订",

      // location
      location_gps_notice: "※ 根据GPS状态，位置可能存在误差。",
      location_checking: "正在确认当前位置...",
      location_valid: "您在可以办理入住的区域。",
      location_not_supported: "此浏览器不支持Geolocation。",
      location_out_of_range: "仅在酒店{{radius}}km范围内可使用服务。",
      location_permission_denied: "位置访问权限被拒绝。请允许位置访问后重试。",
      location_position_unavailable: "无法获取位置。请重试。",
      location_timeout: "位置信息获取超时。请重试。",
      location_default_error: "获取位置时发生未知错误。",

      checkout_confirm: "确认退房吗？",
      checkout_noReentry: "退房后将无法再次进入房间。",
      checkout_complete: "退房完成",
      service_reward_message: "我们将持续提供更优质的服务。\n感谢您的支持。"
    }
  }
};

i18n
  .use(LanguageDetector) // 사용자의 브라우저 언어를 자동으로 감지
  .use(initReactI18next) // i18next를 react-i18next에 전달
  .init({
    resources,
    lng: "ko", // 기본 설정 언어
    fallbackLng: "en", // 번역이 없을 경우 사용할 대체 언어
    interpolation: {
      escapeValue: false // React는 이미 XSS 방지를 하므로 false 설정
    }
  });

export default i18n;
